<wl-sidebar-nav
  [title]="title$ | async"
  [showCategories]="showCategories$ | async"
  [language]="language$ | async"
  [topNavigation]="false"
  [items]="items$ | async"
  wlCSCapture
></wl-sidebar-nav>
